/**
 * @generated SignedSource<<4390b64b6e5c09f30200efd44e104a17>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedTopTileController_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
      readonly code: string | null;
      readonly urlLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly browseContentModule: {
    readonly moduleType: string | null;
  } | null;
  readonly pageType: string | null;
  readonly priceTiles: ReadonlyArray<{
    readonly displayName: string | null;
  } | null> | null;
  readonly " $fragmentType": "SbSharedTopTileController_itemSearch";
};
export type SbSharedTopTileController_itemSearch$key = {
  readonly " $data"?: SbSharedTopTileController_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedTopTileController_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedTopTileController_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "kind": "LinkedField",
          "name": "values",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ],
      "concreteType": "SearchBrowsePriceTile",
      "kind": "LinkedField",
      "name": "priceTiles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "browseContentModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "moduleType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "7ea55b5b8811b148b520ddcfe43d9993";

export default node;
